/* @flow */

import type { Point, Tools } from './Common';
import GlobalManager from './GlobalManager';
import Ramp from './Ramp';

export default class FloatingRamp extends Ramp {
  colorEdge = '#FFFFFF';
  colorFill = '#555555';

  constructor(bottomCenter: Point, radians: number, hypotenuse: number) {
    super(bottomCenter, radians, hypotenuse);
    GlobalManager.canvas.subscribeRamp(tools => this.draw(tools));
  }
  draw(tools: Tools) {
    const { colorEdge, colorFill } = this;
    super.draw(tools, colorEdge, colorFill);
  }
}



// WEBPACK FOOTER //
// ./src/FloatingRamp.js